<script lang="ts" setup>
const model = defineModel({
  type: Boolean,
  required: true,
})

defineProps({
  label: {
    type: String,
    default: '',
  },
  info: {
    type: String,
    default: '',
  },
  disable: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <q-expansion-item header-class="border-radius-3" hide-expand-icon switch-toggle-side>
    <template #header>
      <div class="flex justify-between items-center full-width">
        <q-checkbox v-model="model" :disable="disable" :label="label" color="dark" />
        <q-icon color="dark" name="fa-regular fa-circle-info" size="sm" />
      </div>
    </template>
    <q-card class="bg-transparent" flat>
      <q-card-actions>
        {{ info }}
      </q-card-actions>
    </q-card>
  </q-expansion-item>
</template>

<style lang="scss" scoped></style>
